import {useFileApi} from "../context/ApiContext.tsx";
import {NotificationType, useNotification} from "../context/NotificationContext.tsx";

export const PrintButton = ({ orderId }: { orderId: number }) => {
    const fileApi = useFileApi();

    const { showNotification } = useNotification();

    const handlePrint = async () => {
        try {
            const download = await fileApi.printOrder(orderId);
            download.filename = orderId.toString().concat("-", download.filename);
            const blob = new Blob([base64ToArrayBuffer(download.content)], { type: download.contentType || 'application/octet-stream' });
            // Create a temporary URL for the blob
            const url = window.URL.createObjectURL(blob);
            // Create a temporary anchor element and trigger download
            const a = document.createElement('a');
            a.href = url;
            a.download = download.filename;
            document.body.appendChild(a);
            a.click();
            // Clean up
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
        } catch (error) {
            console.error('Failed to download file:', error);
            showNotification(NotificationType.ERROR, 'Failed to download the file');
        }
    };

    const base64ToArrayBuffer = (base64Content: string) => {
        let binaryString = window.atob(base64Content);
        let binaryLen = binaryString.length;
        let bytes = new Uint8Array(binaryLen);
        for (let i = 0; i < binaryLen; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        return bytes;
    }

    return (
        <div className="flex space-x-2">
            <button
                onClick={handlePrint}
                className="px-3 py-1 text-sm bg-blue-600 font-medium text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 hover:cursor-pointer"
            >
                Print Order
            </button>
        </div>
    );
};